var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M8.36,0a1.09,1.09,0,0,1,.13,2.17h-5a1.34,1.34,0,0,0-1.33,1.2v17.1a1.34,1.34,0,0,0,1.2,1.33h5A1.09,1.09,0,0,1,8.49,24h-5A3.51,3.51,0,0,1,0,20.68V3.52A3.51,3.51,0,0,1,3.32,0h5Zm9.16,5.08.1.09,6.06,6.06,0,0,.05.05-.07-.07a.52.52,0,0,1,.1.11,1.13,1.13,0,0,1,.12.21h0v0l0,.07v0s0,0,0,.08v.05a.13.13,0,0,0,0,.06V12a.91.91,0,0,1,0,.17v0a.29.29,0,0,1,0,.09v0l0,.07s0,0,0,0a1.13,1.13,0,0,1-.12.21h0l0,0-.05.05,0,0-6.06,6.06A1.09,1.09,0,0,1,16,17.39l.09-.1,4.19-4.2H8.36a1.09,1.09,0,0,1-.12-2.17h12l-4.19-4.2A1.08,1.08,0,0,1,16,5.27l.09-.1A1.08,1.08,0,0,1,17.52,5.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.71da91603bb335682d5f41072a7f4e18.svg";
export { ForwardRef as ReactComponent };